import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { requestHHStore } from "@src/entities/requestHH";
import { IRequest } from "../../model/types";
import { LastRequestCard } from "../LastRequestCard/LastRequestCard";
import { LastRequestsEmpty } from "../LastRequestsEmpty/LastRequestsEmpty";
import userImage from "@src/shared/assets/user-from-card.svg";

import styles from "./LastRequests.module.scss";

interface LastRequestsProps {
  items: IRequest[];
}

export const LastRequests = ({ items }: LastRequestsProps) => {
  const navigate = useNavigate();

  const setRequestHHParams = requestHHStore(
    (state) => state.setRequestHHParams,
  );

  const handleRepeat = (request: IRequest) => {
    if (!request.params) return;

    setRequestHHParams(request.params);
    navigate("/change-search-query");
  };

  const handleShowAll = () => {
    navigate("/search-history");
  };

  return (
    <section className={styles.wrapper}>
      <div className={styles.header}>
        <h2 className={styles.title}>Последние запросы</h2>

        {!!items.length && (
          <Button
            variant="text"
            className={styles.showAllButton}
            onClick={handleShowAll}
          >
            Посмотреть все
          </Button>
        )}
      </div>

      {!items.length ? (
        <LastRequestsEmpty />
      ) : (
        <div className={styles.list}>
          {items.map((request) => (
            <LastRequestCard
              key={request.request_uuid}
              request={request}
              onRepeat={handleRepeat}
              iconSrc={userImage}
            />
          ))}
        </div>
      )}
    </section>
  );
};
